import { render } from "./GenderSelect.vue?vue&type=template&id=363122b8&scoped=true"
import script from "./GenderSelect.vue?vue&type=script&lang=js"
export * from "./GenderSelect.vue?vue&type=script&lang=js"

import "./GenderSelect.vue?vue&type=style&index=0&id=363122b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363122b8"]])

export default __exports__